import axios from "axios";

const HOST = process.env.VUE_APP_HOST || "frisbuy.ru";

const INTERACTION_URL = `https://${HOST}/fb/post/interaction`;

function getCookie(name) {
  // debugger;

  const value = `${document.cookie}`;
  const parts = value.split(`${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
}

export function getAnonimousUserCode() {
  const COOKIE_CODE_NAME = encodeURIComponent("_Frisbuy_Anonymous_User_Code");

  const CODE_FROM_COOKIE = getCookie(COOKIE_CODE_NAME);
  if (CODE_FROM_COOKIE) {
    return CODE_FROM_COOKIE;
  } else {
    const HOST = document.location.hostname;
    const USER_AGENT = navigator.userAgent.split("/")[0];
    const RANDOM_NUMBER = Math.random().toString().slice(2, 15);
    const CODE = encodeURIComponent(`${HOST}-${USER_AGENT}-${RANDOM_NUMBER}`);

    const SECONDS_IN_YEAR = "31536000";
    const COOKIE_TIME_SECONDS = SECONDS_IN_YEAR;

    document.cookie = `${COOKIE_CODE_NAME}=${CODE}; max-age=${COOKIE_TIME_SECONDS}; Path=/; SameSite=None; Secure`;

    return CODE;
  }
}

export async function sendInteraction(interaction) {
  setRandomCookieValueForFixBackend();

  try {
    const result = await axios.post(INTERACTION_URL, interaction);

    setRandomCookieValueForFixBackend();

    return result;
  } catch (e) {
    setRandomCookieValueForFixBackend();

    throw Error(e.response.data.request.error, {
      status: e.request.status,
    });
  }
}

function setRandomCookieValueForFixBackend() {
  const COOKIE_NAME = encodeURIComponent("_customerWidget");

  const RANDOM_NUMBER = Math.random().toString().slice(2, 15);

  document.cookie = `${COOKIE_NAME}=${RANDOM_NUMBER}; Path=/; SameSite=None; Secure`;
}
